<p-dialog [(visible)]="displayConfigExternalClient" (onHide)="closeConfigModal()" header="Configure {{configHeader}}" class="configureEmail"
    [modal]="true" [style]="{width: '50em'}">
    <div class="p-grid w-100">
        <ng-container *ngFor="let client of configList">
            <div class="p-col p-sm-12 p-md-12 p-text-center">
                <h5>
                    <a class='pointer' style="color: rgb(73 80 87);" (click)="configureExternalClient(client)">
                        <img [src]="client.image" [alt]="client.name"
                            [ngStyle]="client.name == 'Gmail' && {'margin-top': '12%', 'margin-bottom': '12%'}" />
                        <div>{{ client.name }}</div>
                    </a>
                </h5>
            </div>
        </ng-container>
    </div>
</p-dialog>